import { renderRoutes } from 'react-router-config';

import routes from './routes';

const ShutterbugMasterRoute = () => renderRoutes(routes);

export default ShutterbugMasterRoute;
